module.exports = __webpack_public_path__ + "img/DCU.1de73a06.png";